import React from 'react'

function Plastic() {
  return (
    <div>Plastic</div>
  )
}

export default Plastic